import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//   import { useNavigate } from "react-router-dom";
//   import withReactContent from "sweetalert2-react-content";
//   import Swal from "sweetalert2";
//   import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
//   import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
//   import { useCheckUserPermission } from "../../common/userPermission";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import HeaderModule from "../../components/Header/HeaderModule";
import { dateFormat } from "../../common/common";

//   const customerDelete = "customerDelete";

const BusinessCustomerTransaction = () => {
  const user_data = useSelector((state) => state.user_data);
  // const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
    },
    // {
    //     header: "Business ID",
    //     accessorKey: "businessId",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Customer ID",
    //     accessorKey: "selectedCustomer",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    {
      header: "Appointment Date",
      accessorKey: "Date",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ row }) => <span>{dateFormat(row.original.Date)}</span>,
    },
    // {
    //     header: "Start Time",
    //     accessorKey: "startTime",
    //     enableSorting: true,
    //     sortingFn: "time",
    // },
    // {
    //     header: "End Time",
    //     accessorKey: "endTime",
    //     enableSorting: true,
    //     sortingFn: "time",
    // },
    // {
    //     header: "Is Group",
    //     accessorKey: "IsGroup",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //     Cell: ({ row }) => (
    //         <span>{row.original.IsGroup === 1 ? "Yes" : "No"}</span>
    //     ),
    // },
    // {
    //     header: "Created At",
    //     accessorKey: "createdAt",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    //     Cell: ({ row }) => <span>{dateFormat(row.original.createdAt)}</span>,
    // },
    // {
    //     header: "Modified At",
    //     accessorKey: "modifiedAt",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    //     Cell: ({ row }) => <span>{dateFormat(row.original.modifiedAt)}</span>,
    // },
    // {
    //     header: "Created By",
    //     accessorKey: "createdBy",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Deleted At",
    //     accessorKey: "deletedAt",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    //     Cell: ({ row }) =>
    //         row.original.deletedAt ? (
    //             <span>{dateFormat(row.original.deletedAt)}</span>
    //         ) : (
    //             <span className="text-muted">—</span>
    //         ),
    // },
    // {
    //     header: "Cancellation Message",
    //     accessorKey: "cancellationMessage",
    //     enableSorting: false,
    //     Cell: ({ row }) => (
    //         <span>
    //             {row.original.cancellationMessage || (
    //                 <span className="text-muted">—</span>
    //             )}
    //         </span>
    //     ),
    // },
    // {
    //     header: "Is Home Service",
    //     accessorKey: "isHomeService",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //     Cell: ({ row }) => (
    //         <span>{row.original.isHomeService === 1 ? "Yes" : "No"}</span>
    //     ),
    // },
    {
      header: "Payment Created",
      accessorKey: "paymentCreated",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ row }) => <span> {row.original.paymentCreated && dateFormat(row.original.paymentCreated)}</span>,
    },
    {
      header: "Payment ID",
      accessorKey: "paymentIntent",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Payment Status",
      accessorKey: "paymentStatus",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Status",
      accessorKey: "status",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Currency",
      accessorKey: "currency",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
  ];

  // const route = all_routes;

  const prodcutDataListApi = async () => {
    setLoading(true);
    const response = await apiHandler({
      method: "GET",
      route: `Business/businessCustomerTransactionList?businessId=${
        // businessCustomerTransactionList
        user_data?.businessId || 0
      }`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
      setLoading(false);
    } else {
      console.log(response, "data");
      setLoading(false);
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, []);

  const exportData = productlist?.map((items) => {
    return {
      ["Appointment ID"]: items?.ID,
      ["Appointment Date"]: dateFormat(items?.Date),
      ["paymentCreated"]: dateFormat(items?.paymentCreated),
      ["Payment Status"]: items?.paymentStatus,
      ["Status"]: items?.status,
      ["Currency"]: items?.currency,
      ["Payment ID"]: items?.paymentIntent,
    };
  });

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <HeaderModule
            refreshData={prodcutDataListApi}
            exportData={exportData}
          />
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-responsive">
                <CommonMaterialReactTable
                  columns={columns}
                  data={productlist}
                  columnRightPin={["actions"]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessCustomerTransaction;
